/* eslint-disable react-hooks/exhaustive-deps */
import IconModule from "app/common/Icon/IconModule";
import React, { memo, useEffect } from "react";
import { NavLink } from "react-router-dom";
import IconMenu from "../Icon/IconMenu";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { LayoutContext } from "./LayoutContainer";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useState } from "react";
import ScanQRPopup from "app/common/Component/ScanQR/ScanQRPopup";
import localStorageService from "app/services/localStorageService";
import { getImgLogo, getSystemConfig } from "app/common/LocalFunction";
import SelectDefaultDepartment from "app/EgretLayout/SharedCompoents/SelectDefaultDepartment";
import SelectCustomer from "app/EgretLayout/SharedCompoents/SelectCustomer";
import { IconButton } from "@material-ui/core";
import CachedIcon from '@material-ui/icons/Cached';
import AutorenewIcon from '@material-ui/icons/Autorenew';

function LayoutHeader({ module, noneRedirect }) {
  const { t } = useTranslation();

  const { openSidebar, setOpenSidebar, isScreenSm } = useContext(LayoutContext);
  const [openScanPopup, setOpenScanPopup] = useState(false);
  const [showSearchCustomer, setShowSearchCustomer] = useState(false);

  const handleOpenSearchCustomer = () => setShowSearchCustomer(true);
  const handleCloseSearchCustomer = () => setShowSearchCustomer(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isScreenSm &&
        !event.target.closest("#btn-sidebar") &&
        !event.target.closest("#sidebar")
      ) {
        setOpenSidebar(false);
      }
    }

    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const displayName =
    localStorageService?.getLoginUser()?.user?.displayName ||
    localStorageService?.getLoginUser()?.user?.username ||
    "";

  return (
    <header className={`${isMobile ? "header-mobile" : ""} header-container`}>
      {isMobile && (
        <div className="title-web-mobile title-web flex align-center gap-1">
          {getImgLogo({ height: "40px", width: "40px" })}
          <strong>
            {getSystemConfig("ORG_NAME") ||
              (isMobile ? <>{t("nameAppBrief")}</> : <>{t("nameApp")}</>)}
          </strong>
        </div>
      )}
      {isTablet ? (
        <div className="layout-tablet w-full">
          <div className="title-web-mobile title-web flex align-center gap-1">
            {getImgLogo({ height: "40px", width: "40px" })}
            <strong style={{fontSize: '25px'}}>
              {getSystemConfig("ORG_NAME") ||
                (isTablet ? <>{t("nameAppBrief")}</> : <>{t("nameApp")}</>)}
            </strong>
          </div>

          <div className="flex justify-between items-center w-full">
              <h5 className="flex-center text-green">
                {Boolean(module?.navigation) && (
                  <button
                    id="btn-sidebar"
                    className="flex-center mr-1"
                    onClick={() => setOpenSidebar(!openSidebar)}
                  >
                    <IconMenu />
                  </button>
                )}
                {!isMobile && (
                  <>
                    {module?.name
                      ? `${t(module?.name)} / ${displayName}`
                      : displayName}{" "}
                  </>
                )}
              </h5>

              <div
                className={`redirect-module ${isTablet ? "p-0" : ""}`}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <div
                  style={{display: "flex", alignItems: "center",flex: 1 }}
                >
                {isTablet && !showSearchCustomer && (
                  <IconButton onClick={handleOpenSearchCustomer}>
                    <CachedIcon />
                  </IconButton>
                )}

                {isTablet && showSearchCustomer && (
                  <IconButton onClick={handleCloseSearchCustomer}>
                    <AutorenewIcon />
                  </IconButton>
                )}
                {isTablet ? (
                  <div className="fade-wrapper" style={{ flex: 1 }}>
                    <div className={`fade-slide ${showSearchCustomer ? "" : "show"}`}>
                      <SelectCustomer variant="outlined" isMobile />
                    </div>
                    <div className={`fade-slide ${showSearchCustomer ? "show" : ""}`}>
                      <SelectDefaultDepartment variant="outlined" isMobile />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mr-2">
                      <SelectCustomer variant="outlined" isMobile={isMobile}/>
                    </div>
                    <div className="mr-2">
                      <SelectDefaultDepartment variant="outlined" isMobile={isMobile}/>
                    </div>
                  </>
                )}
                </div>
                  <NavLink
                    className="link-redirect-module flex-center ml-2"
                    to="/module"
                  >
                    <IconModule />
                      <strong className="ml-2">{t("module.selectModule")}</strong>
                  </NavLink>
              </div>
          </div>
        </div>
      ) : (
        <div className="flex-center justify-between w-full">
          <h5 className="flex-center text-green">
            {Boolean(module?.navigation) && (
              <button
                id="btn-sidebar"
                className="flex-center mr-1"
                onClick={() => setOpenSidebar(!openSidebar)}
              >
                <IconMenu />
              </button>
            )}
            {!isMobile && (
              <>
                {module?.name
                  ? `${t(module?.name)} / ${displayName}`
                  : displayName}{" "}
              </>
            )}
          </h5>

          {/* Logo được tái sử dụng cho cả hai nhánh */}
          {!isMobile && (
            <h2 className="title-web flex align-center gap-1">
              {getImgLogo({ height: "40px", width: "40px" })}
              <strong>
                {getSystemConfig("ORG_NAME") || <>{t("nameApp")}</>}
              </strong>
            </h2>
          )}

          {noneRedirect ? (
            <div>{/* <LanguageSelect /> */}</div>
          ) : (
            <>
              {/* <span className="mr-4"><LanguageSelect /></span> */}
              <div
                className={`redirect-module ${isMobile ? "p-0" : ""}`}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <div
                  style={{display: "flex", alignItems: "center",flex: 1 }}
                >
                {isMobile && !showSearchCustomer && (
                  <IconButton onClick={handleOpenSearchCustomer}>
                    <CachedIcon />
                  </IconButton>
                )}

                {isMobile && showSearchCustomer && (
                  <IconButton onClick={handleCloseSearchCustomer}>
                    <AutorenewIcon />
                  </IconButton>
                )}
                {isMobile ? (
                  <div className="fade-wrapper" style={{ flex: 1 }}>
                    <div className={`fade-slide ${showSearchCustomer ? "" : "show"}`}>
                      <SelectCustomer variant="outlined" isMobile />
                    </div>
                    <div className={`fade-slide ${showSearchCustomer ? "show" : ""}`}>
                      <SelectDefaultDepartment variant="outlined" isMobile />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mr-2">
                      <SelectCustomer variant="outlined" isMobile={isMobile}/>
                    </div>
                    <div className="mr-2">
                      <SelectDefaultDepartment variant="outlined" isMobile={isMobile}/>
                    </div>
                  </>
                )}
                </div>
                  <NavLink
                    className="link-redirect-module flex-center ml-2"
                    to="/module"
                  >
                    <IconModule />
                    {!isMobile && (
                      <strong className="ml-2">{t("module.selectModule")}</strong>
                    )}
                  </NavLink>
              </div>
            </>
          )}
        </div>
      )}


      {openScanPopup && (
        <ScanQRPopup
          open={openScanPopup}
          handleClose={() => setOpenScanPopup(false)}
        />
      )}
    </header>
  );
}

export default memo(LayoutHeader);
